import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './index.module.css';
import { editAdminImage, selectUserDetails } from '../../../redux/features/auth/authSlice';
import DefaultImage from '../../../assets/images/icons/blank_profile_pic.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-regular-svg-icons';
import { adminChangePassword, editAdminProfileImage } from '../../../redux/features/auth/authService';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import ClipLoader from "react-spinners/ClipLoader";
import { showToast } from '../../../components/ToastMsg';
import GridLoader from 'react-spinners/GridLoader';
import { BeatLoader } from 'react-spinners';

const Profile = () => {
  const dispatch = useDispatch();
  const { details, isUserDetailsLoading } = useSelector(selectUserDetails);
  const { imageUpdateStatus } = useSelector(editAdminImage);
  const [previewEditThumbnailImage, setPreviewEditThumbnailImage] = useState(null);

  const [credentials, setCredentials] = useState({ new_password: '', confirm_password: '' });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirm_passwordVisible, setconfirm_passwordVisible] = useState(false);
  const [errors, setErrors] = useState({ new_password: '', confirm_password: '' });
  const [disabledBtn, setBtnDisable] = useState(false);

  if (isUserDetailsLoading) {
    return <div className={`loader-style`}>
      <GridLoader color="#df771c" />
    </div>;
  }

  if (!details) {
    return <p>No user details found. Please log in.</p>;
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewEditThumbnailImage(e.target.result);
      };
      reader.readAsDataURL(file);
      dispatch(editAdminProfileImage({ file }))
        .unwrap()
        .then((response) => {
          if (response.success === true) {
            showToast("success", response.message);
          } else {
            showToast("error", response.message);
          }
        })
        .catch((error) => {
          showToast("error", error.message);
        });
    }
  };

  const validatePassword = () => {
    const errors = {};
    if (!credentials.new_password) {
      errors.new_password = 'Password is required.'
    } else if (credentials.new_password.length < 6){
      errors.new_password = 'Password is required at least 6 characters.'
    }
    if (!credentials.confirm_password) {
      errors.confirm_password = 'Confirm Password is required.'
    }
    if (credentials.new_password !== credentials.confirm_password) {
      errors.confirm_password = 'Password & Confirm Password must be matched.'
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return false;
    } else {
      return true;
    }
  }

  const handlePasswordChange = async () => {
    if (validatePassword()) {
      setBtnDisable(true);
      try {
        const response = await dispatch(adminChangePassword(credentials)).unwrap()
        if (response.success === true) {
          showToast("success", response.message);
          setBtnDisable(false);
          setCredentials({ new_password: '', confirm_password: '' });
        } else {
          showToast("error", response.message);
          setBtnDisable(false);
        }
      }
      catch (error) {
        showToast("error", error.message);
        setBtnDisable(false);
      };
    }
  }

  return (
    <div className={`main-card`}>
      <h1 className={`body-title`}>Profile</h1>
      <div className={styles.formContainer}>
        <form className={styles.paymentForm}>
          <div className={styles.profileRow}>
            <div className={styles.profilePicture}>
              <img src={previewEditThumbnailImage ? previewEditThumbnailImage : details?.image_url ? details?.image_url : DefaultImage} className={styles.imageSec} alt='Profile' />
            </div>
            <div className={styles.nameSec}>
              <p className={styles.name}>{details?.full_name}</p>
              <p className={styles.email}>{details?.email}</p>
              <p className={styles.email}>{details?.phone_number}</p>
            </div>
          </div>
        </form>
      </div>
      <h1 className={`body-title ${styles.passDiv}`}>Create New Password</h1>
      <div className={styles.formContainer}>
        <form className={styles.paymentForm}>
          <div className={styles.inputRow}>
            <div className={styles.paymentInputFormGroup}>
              <div className={`${styles.paymentInputGroup} input-group`}>
                <div>
                  <label className={`form-label`}>Password</label>
                </div>
                <input
                  type={passwordVisible ? "text" : "password"}
                  placeholder="********************"
                  value={credentials.new_password}
                  onChange={(e) => {
                    setCredentials({ ...credentials, new_password: e.target.value });
                    setErrors({ ...errors, new_password: '' })
                  }}
                  className={`${styles.paymentInput} primary-input`}
                />
                {!passwordVisible ?
                  <FontAwesomeIcon icon={faEyeSlash} style={{ marginLeft: '-40px' }} onClick={() => setPasswordVisible(true)} /> :
                  <FontAwesomeIcon icon={faEye} style={{ marginLeft: '-40px' }} onClick={() => setPasswordVisible(false)} />}
              </div>
              {errors.new_password && (
                <p className={`text-danger`}>{errors.new_password}</p>
              )}
            </div>
            <div className={styles.paymentInputFormGroup}>
              <div className={` ${styles.paymentInputGroup} input-group`}>
                <div>
                  <label className={`form-label`}>Confirm Password</label>
                </div>
                <input
                  type={confirm_passwordVisible ? "text" : "password"}
                  placeholder="********************"
                  value={credentials.confirm_password}
                  onChange={(e) => {
                    setCredentials({ ...credentials, confirm_password: e.target.value });
                    setErrors({ ...errors, confirm_password: '' })
                  }}
                  className={`${styles.paymentInput} primary-input`}
                />
                {!confirm_passwordVisible ?
                  <FontAwesomeIcon icon={faEyeSlash} style={{ marginLeft: '-40px' }} onClick={() => setconfirm_passwordVisible(true)} /> :
                  <FontAwesomeIcon icon={faEye} style={{ marginLeft: '-40px' }} onClick={() => setconfirm_passwordVisible(false)} />}

              </div>
              {errors.confirm_password && (
                <p className={`text-danger`}>{errors.confirm_password}</p>
              )}
            </div>
          </div>
          <button type="button" className={`btn-primary`} onClick={handlePasswordChange} disabled={disabledBtn}>
            {disabledBtn? <BeatLoader color='#FFFFFF'/> : `Save Password`}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Profile;